import { CommissionInvoiceDTO } from '../../../types/commission-invoice.types';

type CommissionPaymentPermissionChecker = (permission: string) => boolean;

type CommissionPaymentUser = {
  expert_id?: string;
  organization_id?: string;
  linked_accounts?: Array<{
    key?: string;
    field_value?: string;
    field_name?: string;
  }>;
};

export function canUserManageCommissionPayment(
  invoice: Pick<
    CommissionInvoiceDTO,
    | 'invoice_recipient_type'
    | 'invoice_recipient_expert_id'
    | 'invoice_recipient_organization_id'
  >,
  user: CommissionPaymentUser | null | undefined,
  hasPermission: CommissionPaymentPermissionChecker,
  permissions: { createAny: string }
): boolean {
  if (hasPermission(permissions.createAny)) {
    return true;
  }

  return isCurrentUserInvoicePayer(invoice, user);
}

function isCurrentUserInvoicePayer(
  invoice: Pick<
    CommissionInvoiceDTO,
    | 'invoice_recipient_type'
    | 'invoice_recipient_expert_id'
    | 'invoice_recipient_organization_id'
  >,
  user: CommissionPaymentUser | null | undefined
): boolean {
  switch (invoice.invoice_recipient_type) {
    case 'expert_individual':
      return (
        !!user?.expert_id &&
        user.expert_id === invoice.invoice_recipient_expert_id
      );
    case 'expert_organization':
      return currentUserOrganizationIds(user).includes(
        invoice.invoice_recipient_organization_id ?? ''
      );
    default:
      return false;
  }
}

function currentUserOrganizationIds(
  user: CommissionPaymentUser | null | undefined
): string[] {
  const ids = user?.organization_id ? [user.organization_id] : [];
  ids.push(
    ...(user?.linked_accounts
      ?.filter((account) => {
        const key = account.key?.toLowerCase() ?? '';
        const fieldName = account.field_name?.toLowerCase() ?? '';
        return (
          key.includes('organization') || fieldName.includes('organization')
        );
      })
      .map((account) => account.field_value)
      .filter((value): value is string => !!value) ?? [])
  );
  return ids;
}
